module.exports = __webpack_public_path__ + "static/media/minus_accessories.6c213f99.svg";